"use strict";

exports.__esModule = true;

var Metrics_1 = require("./Metrics");

var Log_1 = require("../Log");

var GoogleAnalyticsAppender =
/** @class */
function () {
  /**
   *
   * @param excludedEvents GA имеет лимит на количество отправляемых событий в месяц.
   * Иногда удобно ограничить отправку событий по определенному правилу.
   * И собирать метрики только определенное время или по выбранным событиям.
   * Примеры:
   * category:action:value
   * category:action
   * category
   */
  function GoogleAnalyticsAppender(gaId, excludedEvents) {
    this.excludedEvents = excludedEvents;
    this.log = Log_1.LogManager.getLog(Metrics_1.LOG_PREFIX + "GAAppender");
    this.initGA(gaId);
  }

  GoogleAnalyticsAppender.prototype.append = function (_a) {
    var category = _a.category,
        action = _a.action,
        label = _a.label,
        value = _a.value;

    if (!ga) {
      return;
    }

    var eventInStr = [category, action, label].filter(Boolean).join(':');
    var exclude = this.excludedEvents && this.excludedEvents.some(function (excludedEvent) {
      return eventInStr !== '' && eventInStr.indexOf(excludedEvent) === 0;
    });

    if (exclude) {
      return;
    } // GA принимает только number как значение для событий.


    if (value !== undefined && typeof value !== 'number') {
      this.log.warn("Can't send " + typeof value + " as event value");
    } else {
      ga('send', 'event', category, action, label, value);
    }
  };

  GoogleAnalyticsAppender.prototype.initGA = function (gaId) {
    try {
      /* tslint:disable:only-arrow-functions */

      /* tslint:disable:ban-comma-operator */
      // prettier-ignore
      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments); // @ts-ignore
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), // @ts-ignore
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
      /* tslint:enable:only-arrow-functions */

      /* tslint:enable:ban-comma-operator */


      ga('create', gaId, 'auto');
      ga('send', 'pageview');
    } catch (e) {
      this.log.error("Can't init google analytics " + e.message);
    }
  };

  return GoogleAnalyticsAppender;
}();

exports.GoogleAnalyticsAppender = GoogleAnalyticsAppender;